import { Injectable, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileApi } from '../apis/file-api';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private api = inject(FileApi);
  private sanitizer = inject(DomSanitizer);

  private _imageDict: any = {};
  private _imageDictHr: any = {};

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  private convertBlob(blob: any) {
    if (!blob) return;
    if (blob.size === 0) return;
    let objectURL = URL.createObjectURL(blob);
    let c = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    return c;
  }

  getThumbnailById(id: string) {
    let c = this._imageDict[id];
    if (c) {
      return Promise.resolve(c);
    } else {
      return this.api.getThumbnailById(id).then((blob: any) => {
        let c = this.convertBlob(blob);
        this._imageDict[id] = c;
        return c;
      });
    }
  }

  async getHighResolutionById(id: string) {
    let c = this._imageDictHr[id];
    if (c) {
      return c;
    } else {
      let blob = await this.api.getHighResolutionById(id);
      // let objectURL = URL.createObjectURL(blob);
      // let c = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      let c = this.convertBlob(blob);
      this._imageDictHr[id] = c;
      return c;
    }
  }

  async getPosesCountById(id: string) {
    let count = await this.api.getPosesCountById(id);
    return count;
  }

  async getPoseById(id: string, index: number) {
    let blob = await this.api.getPoseById(id, index);
    // let objectURL = URL.createObjectURL(blob);
    // let res = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    let c = this.convertBlob(blob);
    return c;
  }

  async getCustomerIcon() {
    let blob = await this.api.getCustomerIcon();
    // let objectURL = URL.createObjectURL(blob);
    // return this.sanitizer.bypassSecurityTrustUrl(objectURL);
    let c = this.convertBlob(blob);
    return c;
  }

  async getWallpaper() {
    let blob = await this.api.getWallpaper();
    let objectURL = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustUrl(objectURL);
    // return objectURL;
  }

  async uploadAvatarImage(form: any) {
    return await this.api.uploadAvatarImage(form);
  }

  async getAvatarUrl(uid: string) {
    let blob = await this.api.getAvatar(uid);
    return this.convertBlob(blob);
  }
}
